export default {
    state: {
        avrModel: {
            id:     null,
            title:  null
        }
    },
    getters: {
        getAvrModel(state){return state.avrModel}
    },
    mutations: {
        setAvrModel(state, data){return state.avrModel = data}
    },
    actions: {
        avrModel(context, data){context.commit('setAvrModel', data)}
    }
}